import { BASE_URL } from "../constants";

import { getAuthHeader } from "../utils";

export async function createBulkMedicalCases(casesData) {
  try {
    const response = await fetch(`${BASE_URL}insurance/bulk-medical-cases/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify(casesData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || "Error desconocido al crear casos masivos");
    }

    const result = await response.json();
    
    if (result.errors && result.errors.length > 0) {
      return {
        type: "partial_success",
        message: `Se crearon ${result.successes} de ${result.total_cases} casos. ${result.errors} fallaron.`,
        totalCases: result.total_cases,  // Nuevo campo
        successes: result.successes,    // Nuevo campo
        errors: result.errors,          // Nuevo campo
        details: result.details,        // Nuevo campo (created + failed)
        caseIds: result.details?.created?.map(c => c.id) || [], // Extrae IDs
      };
    }

    // 2. Éxito total: devuelve todos los datos
    return {
      type: "success",
      message: `Todos los ${result.total_cases} casos se crearon exitosamente.`,
      totalCases: result.total_cases,
      successes: result.successes,
      details: result.details,
      caseIds: result.details?.created?.map(c => c.id) || [],
    };
  } catch (error) {
    console.error("Error en createBulkMedicalCases:", error);
    return {
      type: "error",
      message: error.message || "Error al procesar la carga masiva",
    };
  }
}


export async function fetchCompanyClientId() {
  try {
    const response = await fetch(`${BASE_URL}insurance/get-company-id/`, {
      method: "GET",
      headers: {
        "Accept": "application/json",
        ...getAuthHeader(),
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP status ${response.status}`);
    }

    const data = await response.json();
    console.log("Datos recibidos:", data); // Verifica aquí

    // Asegúrate de que 'company_client_ids' exista
    if (data && Array.isArray(data.company_client_ids)) {
      return data.company_client_ids;
    } else {
      console.error("Error: Los IDs de compañía no son válidos");
      return null;
    }
  } catch (error) {
    console.error("Error obteniendo company_client_ids:", error.message);
    return null;
  }
}